import { ApiModule } from '@core';
import { type PaginatedResponseData } from '@common';
import type { Statistics, StatisticsDetails, StatisticsItem, StatisticsWizardListItem } from '../models';

export class StatisticsApi extends ApiModule {
  protected endpoint = '/maximap/statistics';

  public getStatistics(filters: any = {}) {
    return this.api.get<PaginatedResponseData<StatisticsItem>>(`${this.endpoint}`, { params: filters });
  }

  public deleteStatistics(id: string) {
    return this.api.delete(`${this.endpoint}/${id}`);
  }

  public createStatistics(statistics: Statistics) {
    return this.api.post<any, Statistics>(`${this.endpoint}/create`, statistics);
  }

  public getStatisticsWizard(params: any) {
    return this.api.get<StatisticsWizardListItem[]>(`${this.endpoint}/wizard`, { params });
  }

  public getStatisticsPreview(params: any) {
    return this.api.get<any>(`${this.endpoint}/preview`, { params });
  }

  public getStatisticsPreviewFile(params: any) {
    return this.api.get<any>(`${this.endpoint}/preview-file`, { params });
  }

  public getStatisticsById(id: string) {
    return this.api.get<StatisticsDetails>(`${this.endpoint}/${id}`);
  }
}
